import type { ReactNode } from 'react';
import { NavLink, useNavigate } from 'react-router';
import { useAuth } from '../auth/auth-context';

export function Layout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="app">
      <header className="topbar">
        <h1>mbtiler admin</h1>
        <nav>
          <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : undefined)}>
            대시보드
          </NavLink>
          <NavLink to="/mbtiles" className={({ isActive }) => (isActive ? 'active' : undefined)}>
            mbtiles
          </NavLink>
          <NavLink to="/api-keys" className={({ isActive }) => (isActive ? 'active' : undefined)}>
            API keys
          </NavLink>
          <NavLink
            to="/read-tokens"
            className={({ isActive }) => (isActive ? 'active' : undefined)}
          >
            read-tokens
          </NavLink>
          <NavLink
            to="/examples"
            className={({ isActive }) => (isActive ? 'active' : undefined)}
          >
            examples
          </NavLink>
        </nav>
        <span className="user">{user?.username}</span>
        <button className="logout" onClick={handleLogout} type="button">
          로그아웃
        </button>
      </header>
      <main>{children}</main>
    </div>
  );
}
